module.exports = __webpack_public_path__ + "img/first.7b8b666b.png";